<template>
  <div>
    <div class="intents-table" v-if="!showPhrasesTable">
      <div class="has-text-right">
        <span class="icon is-size-3" @click="closeTableView()">
          <i class="fas fa-times"></i>
        </span>
      </div>
      <div class="section mt-6" v-if="type === 1">
        <span class="title">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_TITLE_MORE_FREQUENTS_TYPE1') }}</span>
        <table v-if="data && data.intentsFrequents.length" class="table">
          <tr>
            <th> {{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_MORE_FREQUENTS_INTENT_TYPE1') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_#') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_GOOD') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_BAD') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_RIGHT') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_DOUBT') }}</th>
          </tr>
          <tr v-for="(intent, index) in data.intentsFrequents" :key="index">
            <td class="intent-name" @click="showPhrasesTableView(intent)">{{ intent.name }}</td>
            <td class="has-text-right total">{{ intent.total }}</td>
            <td class="has-text-right total">{{ intent.rateOK }}</td>
            <td class="has-text-right total">{{ intent.rateKO }}</td>
            <td class="has-text-right ok">{{ intent.percentOK }}%</td>
            <td class="has-text-right doubt">{{ intent.percentDuda }}%</td>
          </tr>
        </table>
        <div v-else class="no-data">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_TYPE1_NO_DATA') }}</div>
      </div>
      <div class="section mt-6" v-if="type === 2">
        <span class="title">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_TYPE2_NEED_REVISION') }}</span>
        <table v-if="data && data.intentFeedbackKOs.length" class="table">
          <tr>
            <th>{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_INTENT_TYPE2') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_GOOD') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_BAD') }}</th>
            <th class="has-text-right">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_KO') }}</th>
          </tr>
          <tr v-for="(intent, index) in data.intentFeedbackKOs" :key="index">
            <td>{{ intent.name }}</td>
            <td class="has-text-right total">{{ intent.total }}</td>
            <td class="has-text-right total">{{ intent.rateOK }}</td>
            <td class="has-text-right total">{{ intent.rateKO }}</td>
            <td class="has-text-right ko">{{ intent.negative }}%</td>
          </tr>
        </table>
        <div v-else class="no-data">{{ CONSTANTS.getCopy('ANALYTICSINTENTSTABLE_TYPE2_NO_DATA') }}</div>
      </div>
    </div>
    <IntentsPhrasesTable v-if="showPhrasesTable" :data="phrasesTableData" :intentName="intentName"
      @backIntentsTable="backIntentsTable" @closeTableView="closeTableView" />
  </div>
</template>

<script>

import IntentsPhrasesTable from './IntentsPhrasesTable.vue'

export default {
  components: { IntentsPhrasesTable },
  props: {
    data: Object,
    type: Number,
    client: Number
  },
  data () {
    return {
      showPhrasesTable: false,
      phrasesTableData: null,
      intentName: null
    }
  },
  methods: {
    closeTableView () {
      this.$emit('closeTableView')
    },
    showPhrasesTableView (intent) {
      this.api.post('/Analitics_Intents_Phrases/', { typeSearch: 1, idClient: this.client, idIntent: intent.id }).then((response) => {
        this.showPhrasesTable = true
        this.phrasesTableData = response
        this.intentName = intent.name
      })
    },
    backIntentsTable () {
      this.showPhrasesTable = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analytics/AnalyticsIntentsTable.vue